import { getClientSession } from "@/utils/sakaClientSessionHelper";
import Cookies from "js-cookie";
import { MVC_SESSION_COOKIE_NAMES } from "@/constants/cookieNames";
import { getT5009Data } from "@/utils/decodeMVCCookiesToJson";

/**
 * Client-side session headers helper
 * Bu dosya TAMAMEN client-side için, server-side import'ları YOK
 * @returns {{ "Turna-Session-Id": string, "Turna-Session-Token": string }}
 */
export function getClientSessionHeaders() {
  try {
    // Client-side'da SAKA session'ı kontrol et
    if (typeof window !== "undefined") {
      // Önce cookie'den SAKA session'ı kontrol et
      const sakaSession = getClientSession();
      
      if (sakaSession?.SessionId && sakaSession?.SessionToken) {
        return {
          "Turna-Session-Id": sakaSession.SessionId,
          "Turna-Session-Token": sakaSession.SessionToken,
        };
      }

      // SAKA session yoksa MVC cookie'lerini kontrol et
      const ts5009Cookie = Cookies.get(MVC_SESSION_COOKIE_NAMES.TS5009);
      if (ts5009Cookie) {
        const ts5009Data = getT5009Data(ts5009Cookie);
        if (ts5009Data?.sessionId && ts5009Data?.sessionToken) {
          return {
            "Turna-Session-Id": ts5009Data.sessionId,
            "Turna-Session-Token": ts5009Data.sessionToken,
          };
        }
      }

      // Fallback: localStorage'dan kontrol et (eski yapı için)
      const localSession = JSON.parse(
        localStorage.getItem("saka-session") || "{}",
      );

      if (localSession?.SessionId && localSession?.SessionToken) {
        return {
          "Turna-Session-Id": localSession.SessionId,
          "Turna-Session-Token": localSession.SessionToken,
        };
      }
    }

    return {
      "Turna-Session-Id": "",
      "Turna-Session-Token": "",
    };
  } catch (error) {
    console.error("Error getting client session headers:", error);
    return {
      "Turna-Session-Id": "",
      "Turna-Session-Token": "",
    };
  }
}

